// PC和WAP统一消息提示
let $unifiedMessage;

(async () => {
  if (process.env.VUE_APP_IS_WAP) {
    // 动态导入Toast组件
    ({ Toast: $unifiedMessage } = await import('vh5-ui'));
  } else {
    // 动态导入message组件
    ({ $message: $unifiedMessage } = await import('@/app-shared/extension/message.js'));
  }
})();

export { $unifiedMessage };
